import { CustomMap } from '@vendor/libs/maps/maps';
import { ApiaryFeatures } from '@vendor/libs/maps/features';
import { DrawApiaryInteraction } from '@vendor/libs/maps/interactions';
import MapUtils from '@vendor/js/map-utils';
const _ApiariesMapHandler = (function () {
    const card = $('[data-app-apiary_map_card]');
    let apiaryFeatures = null;
    let id = null;
    /**
     * Initializes the map and sets up the necessary features and interactions.
     *
     * @function initMap
     * @returns {void}
     */
    const initMap = () => {
        const map = CustomMap.getMap('map');
        if (!map) {
            return;
        }
        apiaryFeatures = new ApiaryFeatures({
            visibilityListed: false,
            visibilityName: 'apiaries-current',
            relatedName: 'apiary-buffers-current',
        });
        map.addFeatures('apiaries', apiaryFeatures);
    };
    /**
     * Sets up and adds a draw interaction for creating apiaries on the map.
     *
     * @returns {void}
     */
    const addDrawInteraction = () => {
        const map = CustomMap.getMap('map');
        if (!map) {
            return;
        }
        // add interaction
        const drawApiaryInteraction = new DrawApiaryInteraction();
        map.addInteraction('draw-apiary', drawApiaryInteraction);
        drawApiaryInteraction.on('end', function ({ feature }) {
            setApiaryLocation(feature);
        });
    };
    const setApiaryLocation = (geo, fit = false, editInfo = true, highlight = true) => {
        const geojson = MapUtils.geojsonFromAny(geo);
        if (!apiaryFeatures) {
            return;
        }
        let map = CustomMap.getMap('map');
        if (!map) {
            return;
        }
        apiaryFeatures.clear();
        let longitude = geojson.geometry.coordinates[0].toFixed(4);
        let latitude = geojson.geometry.coordinates[1].toFixed(4);
        card.html(`
        Ustalono pozycję pasieki: <br />
        <strong>${latitude}, ${longitude}</strong>
        ${editInfo
            ? '<br /><br /> Kliknij w dowolne miejsce na mapie, aby zmienić pozycję pasieki.'
            : ''}
    `);
        id = geojson.id ?? null;
        const features = apiaryFeatures.fromGeoJSON(geojson);
        for (const feature of features) {
            feature.set('highlighted', true);
        }
        const input = $('[name="geojson"]');
        if (input.length) {
            input.val(geojson.toString()).trigger('change');
        }
        if (fit) {
            apiaryFeatures.fit({ maxZoom: 16 });
        }
    };
    const setupRowClickEvent = (mapId) => {
        let map = CustomMap.getMap(mapId);
        $('body').on('click', '[data-app-apiary_bbox]', function (e) {
            if ($(e.target).is('button') || $(e.target).is('a')) {
                return;
            }
            if (!map) {
                map = CustomMap.getMap(mapId);
                if (!map) {
                    return;
                }
            }
            const geoJson = MapUtils.geojsonFromAny($(this).attr('data-app-apiary_bbox'));
            map.fitTo(geoJson, { maxZoom: 12 });
        });
    };
    return {
        // Public functions
        init: function () {
            initMap();
        },
        addDrawInteraction,
        setApiaryLocation,
        setupRowClickEvent,
    };
})();
window.ApiariesMapHandler = _ApiariesMapHandler;
